// Call plugin.
import { CALL_STATES } from '../constants'

/**
 * Call selectors.
 * Handles retrieving data from the `state.call.calls` substate.
 */

/**
 * Get the list of all calls this session.
 * @method getCalls
 * @param  {Object} state Redux state.
 * @return {Array} A list of all call objects.
 */
export function getCalls (state) {
  // TODO: cloneDeep?
  return state.call.calls
}

/**
 * Retrieves the list of all on-going calls.
 * @method getActiveCalls
 * @param {Object} state Redux state.
 * @return {Array} A list of call objects.
 */
export function getActiveCalls (state) {
  const endedStates = [CALL_STATES.ENDED, CALL_STATES.CANCELLED]

  return getCalls(state).filter(call => !endedStates.includes(call.state))
}

/**
 * Get the call object of a specific call.
 * @method getCallById
 * @param  {Object} state Redux state.
 * @param  {string} callId The call to retrieve.
 * @return {Object} A call object.
 */
export function getCallById (state, callId) {
  return getCalls(state).find(call => call.id === callId)
}

/**
 * Get the call object with a specific wrtcsSessionId (backend ID).
 * @method getCallByWrtcsSessionId
 * @param  {Object} state Redux state.
 * @param  {string} wrtcsSessionId The call to retrieve.
 * @return {Object} A call object.
 */
export function getCallByWrtcsSessionId (state, wrtcsSessionId) {
  return getCalls(state).find(call => call.wrtcsSessionId === wrtcsSessionId)
}

/**
 * Get the call object with a specific webrtcSessionId.
 * @method getCallByWebrtcSessionId
 * @param  {Object} state Redux state.
 * @param  {string} webrtcSessionId The call to retrieve.
 * @return {Object} A call object.
 */
export function getCallByWebrtcSessionId (state, webrtcSessionId) {
  return getCalls(state).find(call => call.webrtcSessionId === webrtcSessionId)
}

/**
 * Retrieve the call plugin's options.
 * @method getOptions
 * @param  {Object} state Redux state.
 * @return {Object}
 */
export function getOptions (state) {
  return state.config.call
}

/**
 * Retrieve TURN server/credential information.
 */
export function getTurnInfo (state) {
  return state.call.turn
}
